import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  note?: string;
  pulse?: boolean;
};
export function CtaButton({
  children,
  note,
  pulse = true
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-27" data-mp="cjhkaflj3yo5">
      <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className={`${pulse ? 'cta-pulse' : ''} group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold px-6 py-5 text-center font-display text-lg font-extrabold uppercase tracking-wide text-black shadow-[0_10px_34px_rgba(212,175,55,0.28)] transition-colors duration-150 ease-out hover:bg-gold-light focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 md:text-xl`} data-id="element-28" data-mp="qjsbjjqr3f9u">
        <span data-id="element-29" data-mp="15a9amwfwxt3k">{children}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="15b17eal8xwvf" />
      </a>
      {note && <p className="mt-4 text-center text-sm text-neutral-400 md:text-base" data-id="element-31" data-mp="39y7y82d1fe7m">{note}</p>}
    </div>;
}